import type { TrackingLocation } from "./order-tracking-tracking-location-definition";
import type {
  TrackingPageOrder,
  TrackingPageShipment,
} from "./tracking-page-order-definition";

export function locationToQuery(
  location: TrackingLocation | null | undefined,
): string | null {
  if (!location) {
    return null;
  }
  if (typeof location === "string") {
    const trimmed = location.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  const query = [location.city, location.state, location.country]
    .filter(Boolean)
    .join(", ");
  return query.length > 0 ? query : null;
}

export function locationToCityStateLabel(
  location: TrackingLocation | null | undefined,
): string | null {
  if (!location) {
    return null;
  }
  if (typeof location === "string") {
    const trimmed = location.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  const label = [location.city, location.state].filter(Boolean).join(", ");
  return label.length > 0 ? label : null;
}

export function getTrackingMapLocation(
  shipment: TrackingPageShipment | undefined,
  order: TrackingPageOrder,
): TrackingLocation | null {
  const events = shipment?.trackingEvents?.length
    ? [...shipment.trackingEvents].sort(
        (a, b) =>
          (b.timestamp?.getTime?.() ?? 0) - (a.timestamp?.getTime?.() ?? 0),
      )
    : [];
  for (const event of events) {
    if (event.location != null && locationToQuery(event.location)) {
      return event.location;
    }
  }

  const address = order.shippingAddress;
  if (address) {
    const query = [address.city, address.state, address.country]
      .filter(Boolean)
      .join(", ");
    if (query.length > 0) {
      return {
        city: address.city,
        state: address.state,
        country: address.country,
        postalCode: address.postalCode,
      };
    }
  }

  return null;
}

export function getTrackingMapQuery(
  shipment: TrackingPageShipment | undefined,
  order: TrackingPageOrder,
): string | null {
  return locationToQuery(getTrackingMapLocation(shipment, order));
}
